import { graphql, useStaticQuery } from "gatsby";

const useSiteMetadata = () => {
  const result = useStaticQuery(graphql`
    query SiteMetaData {
      site {
        siteMetadata {
          author {
            bio
            name
            photo
            contacts {
              rss
              line
              email
              weibo
              gitlab
              medium
              github
              twitter
              codepen
              youtube
              facebook
              linkedin
              telegram
              instagram
              soundcloud
              mastodon
            }
          }
          menu {
            path
            label
          }
          url
          title
          subtitle
          copyright
          disqusShortname
        }
      }
    }
  `);

  return result?.site?.siteMetadata || {};
};

export default useSiteMetadata;
